export const PRIVACY_SETTINGS_EXIT_SIGNAL = 'privacySettingsExit';
